import { IDbLibFolder } from "../types/database/IDbLibFolder";
import { IFolder } from "../store/modules/library/IFolder";

export const convertTreeToList = (id: string, path: Array<string>, folder: IDbLibFolder): Record<string, IFolder> => {
  const list: Record<string, IFolder> = {};

  list[id] = {
    id,
    title: folder.title,
    path,
    folders: {},
    books: {},
    isContentLoaded: false,
    isWasOpened: folder.isWasOpened,
    isArchived: folder.isArchived,
    dateAdded: folder.dateAdded,
    lastOpenDate: folder.lastOpenDate,
  };

  if (!folder.folders) {
    return list;
  }

  return Object.entries(folder.folders).reduce(
    (acc, [subFolderId, subFolder]) => {
      if (!subFolder.isArchived) {
        acc[id].folders[subFolderId] = subFolderId;
      }

      return ({
        ...acc,
        ...convertTreeToList(subFolderId, [...path, id], subFolder),
      });
    },
    list,
  );
};
